import { render, staticRenderFns } from "./license-list.vue?vue&type=template&id=307a753a&scoped=true&"
import script from "./license-list.vue?vue&type=script&lang=js&"
export * from "./license-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307a753a",
  null
  
)

export default component.exports